import NotificationActions from '../../../actions/NotificationActions';
import { endPoints as GuestEndPoints } from '../../../constants/GuestConstants';
import UserStore from '../../../stores/UserStore';
import AjaxPromises from '../../../utils/AjaxPromises';
import DropdownProfile from './DropdownProfile.react';


class EditExternalPatientAllotments extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading     : false,
            visible     : false,
            licenseNumber: this.props.guest.MJStateIDNo || null,
            licenseEffectiveStartDate: '',
            licenseEffectiveEndDate: '',
            recommendedPlants: null,
            recommendedSmokableQuantity: null,
            flowerOuncesAllowed: null,
            thcOuncesAllowed: null,
            concentrateOuncesAllowed: null,
            infusedOuncesAllowed: null,
            maxConcentrateThcPercentAllowed: null,
            maxFlowerThcPercentAllowed: null,
            hasSalesLimitExemption: null,
        };

        this.adjust = this.adjust.bind(this);
    }

    adjust() {
        var guest = this.props.guest;

        AjaxPromises.POST(GuestEndPoints.EDIT_EXTERNAL_PATIENT_ALLOTMENT, UserStore.getApiData({
            LicenseNumber: guest.MJStateIDNo,
            NewLicenseNumber: this.state.licenseNumber,
            LicenseEffectiveStartDate: this.state.licenseEffectiveStartDate,
            LicenseEffectiveEndDate: this.state.licenseEffectiveEndDate,
            RecommendedPlants: this.state.recommendedPlants,
            RecommendedSmokableQuantity: this.state.recommendedSmokableQuantity,
            FlowerOuncesAllowed: this.state.flowerOuncesAllowed,
            ThcOuncesAllowed: this.state.thcOuncesAllowed,
            ConcentrateOuncesAllowed: this.state.concentrateOuncesAllowed,
            InfusedOuncesAllowed: this.state.infusedOuncesAllowed,
            MaxConcentrateThcPercentAllowed: this.state.maxConcentrateThcPercentAllowed,
            MaxFlowerThcPercentAllowed: this.state.maxFlowerThcPercentAllowed,
            HasSalesLimitExemption: this.state.hasSalesLimitExemption,
            CustomerType: guest.PatientType,
        })).then(res => {
            NotificationActions.addNotification({
                type : res.Result ? 'success' : 'error',
                body : res.Result ? 'Allotment adjusted' : `An error occurred while adjusting patient allotment: ${res.Message}`,
            });


            if (res.Result) {
                this.setState({
                    loading : false,
                    visible : false,
                    licenseNumber: this.props.guest.MJStateIDNo || null,
                    licenseEffectiveStartDate: '',
                    licenseEffectiveEndDate: '',
                    recommendedPlants: null,
                    recommendedSmokableQuantity: null,
                    flowerOuncesAllowed: null,
                    thcOuncesAllowed: null,
                    concentrateOuncesAllowed: null,
                    infusedOuncesAllowed: null,
                    maxConcentrateThcPercentAllowed: null,
                    maxFlowerThcPercentAllowed: null,
                    hasSalesLimitExemption: null,
                });

                this.props.onClose();
            } else {
                this.setState({ loading : false });
            }
        });
    }

    render() {
        return (
            <div className='col-8'>
                <div className='popup popup__transparent'>
                    <div className='popup__content edit-allotments'>

                        <div className='popup-header'>
                            Edit Allotments

                            <div
                                className='popup-close'
                                onClick={() => { 
                                    this.setState({ pin : '', loyalty : 0 });
                                    this.props.onClose();
                                }}>

                                <i className='fa fa-times' aria-hidden='true' />
                            </div>
                        </div>

                        <div className='edit-allotments__content container'>
                            <div className='row' style={{'margin-top':'3rem'}}>
                                <div className='col-6'>
                                    License Number
                                </div>
                                <div className='col-6 edit-allotments__padding-0' >
                                    <input
                                        type='text'
                                        value={this.state.licenseNumber}
                                        className='input-text-1'
                                        onChange={(e) => this.setState({licenseNumber: e.target.value})} />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    License Effective Start Date
                                </div>
                                <div className='col-6 edit-allotments__padding-0' >
                                    <input
                                        type='date'
                                        value={this.state.licenseEffectiveStartDate}
                                        className='input-text-1'
                                        onChange={(e) => this.setState({licenseEffectiveStartDate: e.target.value})} />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    License Effective End Date
                                </div>
                                <div className='col-6 edit-allotments__padding-0' >
                                    <input
                                        type='date'
                                        value={this.state.licenseEffectiveEndDate}
                                        className='input-text-1'
                                        onChange={(e) => this.setState({licenseEffectiveEndDate: e.target.value})} />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    Recommended Plants
                                </div>
                                <div className='col-6 edit-allotments__padding-0' >
                                    <input
                                        type='number'
                                        value={this.state.recommendedPlants}
                                        className='input-text-1'
                                        onChange={(e) => this.setState({recommendedPlants: e.target.value})} />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    Recommended Smokable Quantity
                                </div>
                                <div className='col-6 edit-allotments__padding-0' >
                                    <input
                                        type='number'
                                        value={this.state.recommendedSmokableQuantity}
                                        className='input-text-1'
                                        onChange={(e) => this.setState({recommendedSmokableQuantity: e.target.value})} />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    Flower Ounces Allowed
                                </div>
                                <div className='col-6 edit-allotments__padding-0' >
                                    <input
                                        type='number'
                                        value={this.state.flowerOuncesAllowed}
                                        className='input-text-1'
                                        onChange={(e) => this.setState({flowerOuncesAllowed: e.target.value})} />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    THC Ounces Allowed
                                </div>
                                <div className='col-6 edit-allotments__padding-0' >
                                    <input
                                        type='number'
                                        value={this.state.thcOuncesAllowed}
                                        className='input-text-1'
                                        onChange={(e) => this.setState({thcOuncesAllowed: e.target.value})} />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    Concentrate Ounces Allowed
                                </div>
                                <div className='col-6 edit-allotments__padding-0' >
                                    <input
                                        type='number'
                                        value={this.state.concentrateOuncesAllowed}
                                        className='input-text-1'
                                        onChange={(e) => this.setState({concentrateOuncesAllowed: e.target.value})} />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    Infused Ounces Allowed
                                </div>
                                <div className='col-6 edit-allotments__padding-0' >
                                    <input
                                        type='number'
                                        value={this.state.infusedOuncesAllowed}
                                        className='input-text-1'
                                        onChange={(e) => this.setState({infusedOuncesAllowed: e.target.value})} />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    Max Concentrate THC % Allowed
                                </div>
                                <div className='col-6 edit-allotments__padding-0' >
                                    <input
                                        type='number'
                                        value={this.state.maxConcentrateThcPercentAllowed}
                                        className='input-text-1'
                                        onChange={(e) => this.setState({maxConcentrateThcPercentAllowed: e.target.value})} />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    Max Flower THC % Allowed
                                </div>
                                <div className='col-6 edit-allotments__padding-0' >
                                    <input
                                        type='number'
                                        value={this.state.maxFlowerThcPercentAllowed}
                                        className='input-text-1'
                                        onChange={(e) => this.setState({maxFlowerThcPercentAllowed: e.target.value})} />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    Has Sales Limit Exemption
                                </div>
                                <div className='col-3'>
                                    <DropdownProfile
                                        field='hasSalesLimitExemption'
                                        options={[
                                            { title: '', option: null },
                                            { title: 'Yes', option: true },
                                            { title: 'No', option: false },
                                        ]}
                                        selected={this.state.hasSalesLimitExemption}
                                        onChange={(field, hasSalesLimitExemption) => { this.setState({ hasSalesLimitExemption }); }} />
                                </div>
                            </div>
                            

                            <div className='row' style={{'margin-bottom' : '1rem'}}>
                                <div className='col-2'>
                                    <div
                                        className={'edit-allotments__ok btn-green '}
                                        onClick={this.adjust}>
                                        Save
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default EditExternalPatientAllotments;


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/EditExternalPatientAllotments.react.jsx